import { Controller } from '@hotwired/stimulus'
import { Helpers } from '../helpers';

export default class extends Controller {
  static targets = [
    'payinMethodRadioButtons',
    'cardExplanation',
    'formSubmitButton',
    'modalButton',
    'modalAmount',
    'copiableModalAmount',
  ]

  changePayinMethod(event) {
    const isPayingByCard = event.target.value === 'card';
    this.cardExplanationTarget.classList.toggle('d-none', !isPayingByCard);
    this.formSubmitButtonTarget.classList.toggle('d-none', !isPayingByCard);
    this.modalButtonTarget.classList.toggle('d-none', isPayingByCard);
  }

  changeModalAmount(event) {
    const rawAmount = event.target.value;
    const amount = Helpers.numberToCurrency(rawAmount, 2);

    if (rawAmount === '') {
      this.formSubmitButtonTarget.classList.add('disabled');
      this.modalButtonTarget.classList.add('disabled');
    } else {
      this.formSubmitButtonTarget.classList.remove('disabled');
      this.modalButtonTarget.classList.remove('disabled');
      this.modalAmountTarget.innerHTML = amount;
      this.copiableModalAmountTarget.dataset.targetValue = amount;
    }
  }
}
